/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { DatabaseEntryStatistic } from './DatabaseEntryStatistic';
import {
    DatabaseEntryStatisticFromJSON,
    DatabaseEntryStatisticFromJSONTyped,
    DatabaseEntryStatisticToJSON,
} from './DatabaseEntryStatistic';
import type { DatabaseUser } from './DatabaseUser';
import {
    DatabaseUserFromJSON,
    DatabaseUserFromJSONTyped,
    DatabaseUserToJSON,
} from './DatabaseUser';

/**
 * 
 * @export
 * @interface DatabaseEntry
 */
export interface DatabaseEntry {
    /**
     * 
     * @type {string}
     * @memberof DatabaseEntry
     */
    id?: string;
    /**
     * 
     * @type {DatabaseUser}
     * @memberof DatabaseEntry
     */
    createdBy?: DatabaseUser;
    /**
     * 
     * @type {Date}
     * @memberof DatabaseEntry
     */
    readonly created?: Date;
    /**
     * 
     * @type {DatabaseUser}
     * @memberof DatabaseEntry
     */
    updatedBy?: DatabaseUser;
    /**
     * 
     * @type {Date}
     * @memberof DatabaseEntry
     */
    readonly updated?: Date;
    /**
     * 
     * @type {DatabaseUser}
     * @memberof DatabaseEntry
     */
    owner?: DatabaseUser;
    /**
     * 
     * @type {string}
     * @memberof DatabaseEntry
     */
    belongsTo?: string;
    /**
     * 
     * @type {string}
     * @memberof DatabaseEntry
     */
    readonly rank?: string;
    /**
     * 
     * @type {number}
     * @memberof DatabaseEntry
     */
    readonly numberOfLikes?: number;
    /**
     * 
     * @type {number}
     * @memberof DatabaseEntry
     */
    readonly numberOfComments?: number;
    /**
     * 
     * @type {DatabaseEntryStatistic}
     * @memberof DatabaseEntry
     */
    statistics?: DatabaseEntryStatistic;
    /**
     * 
     * @type {Array<string>}
     * @memberof DatabaseEntry
     */
    likes?: Array<string>;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof DatabaseEntry
     */
    fieldsValues?: { [key: string]: any; };
}

/**
 * Check if a given object implements the DatabaseEntry interface.
 */
export function instanceOfDatabaseEntry(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function DatabaseEntryFromJSON(json: any): DatabaseEntry {
    return DatabaseEntryFromJSONTyped(json, false);
}

export function DatabaseEntryFromJSONTyped(json: any, ignoreDiscriminator: boolean): DatabaseEntry {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'createdBy': !exists(json, 'createdBy') ? undefined : DatabaseUserFromJSON(json['createdBy']),
        'created': !exists(json, 'created') ? undefined : (new Date(json['created'])),
        'updatedBy': !exists(json, 'updatedBy') ? undefined : DatabaseUserFromJSON(json['updatedBy']),
        'updated': !exists(json, 'updated') ? undefined : (new Date(json['updated'])),
        'owner': !exists(json, 'owner') ? undefined : DatabaseUserFromJSON(json['owner']),
        'belongsTo': !exists(json, 'belongsTo') ? undefined : json['belongsTo'],
        'rank': !exists(json, 'rank') ? undefined : json['rank'],
        'numberOfLikes': !exists(json, 'numberOfLikes') ? undefined : json['numberOfLikes'],
        'numberOfComments': !exists(json, 'numberOfComments') ? undefined : json['numberOfComments'],
        'statistics': !exists(json, 'statistics') ? undefined : DatabaseEntryStatisticFromJSON(json['statistics']),
        'likes': !exists(json, 'likes') ? undefined : json['likes'],
        'fieldsValues': !exists(json, 'fieldsValues') ? undefined : json['fieldsValues'],
    };
}

export function DatabaseEntryToJSON(value?: DatabaseEntry | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'createdBy': DatabaseUserToJSON(value.createdBy),
        'updatedBy': DatabaseUserToJSON(value.updatedBy),
        'owner': DatabaseUserToJSON(value.owner),
        'belongsTo': value.belongsTo,
        'statistics': DatabaseEntryStatisticToJSON(value.statistics),
        'likes': value.likes,
        'fieldsValues': value.fieldsValues,
    };
}

